import { code } from "@streamdown/code";
import { memo } from "react";
import remarkBreaks from "remark-breaks";
import remarkGfm from "remark-gfm";
import { Streamdown } from "streamdown";

export type MarkdownProps = {
  children?: string;
  id?: string;
  className?: string;
  isAnimating?: boolean;
};

const remarkPlugins = [remarkGfm, remarkBreaks];

function MarkdownComponent({
  children,
  id,
  className,
  isAnimating = false,
}: MarkdownProps) {
  return (
    <div className={className} data-slot="markdown" id={id}>
      <Streamdown
        isAnimating={isAnimating}
        plugins={{ code }}
        remarkPlugins={remarkPlugins}
        shikiTheme={["github-light", "github-dark"]}
      >
        {children ?? ""}
      </Streamdown>
    </div>
  );
}

const Markdown = memo(MarkdownComponent);
Markdown.displayName = "Markdown";

export { Markdown };
